import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.css']
})
export class BreadCrumbComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
